import type { ContactMethod, Maybe } from "@/graphql/codegen/graphql"
import { ContactChannel } from "@/graphql/codegen/graphql"

export const getPrimaryContactMethods = (
  contactMethods: Maybe<Maybe<ContactMethod>[]>
): {
  email?: Maybe<string>
  phone?: Maybe<string>
  phoneExt?: Maybe<string>
} => {
  const viableMethods = (contactMethods ?? []).filter((contactMethod) => !!contactMethod?.value) as ContactMethod[]

  return {
    email: viableMethods?.find(({ contactChannel }) => contactChannel === ContactChannel.Email)?.value,
    phone: viableMethods?.find(
      ({ contactChannel, sortOrder }) => contactChannel === ContactChannel.Phone && sortOrder === 0
    )?.value,
    phoneExt: viableMethods?.find(
      ({ contactChannel, sortOrder }) => contactChannel === ContactChannel.Phone && sortOrder === 0
    )?.phoneExt,
  }
}
